import { render, staticRenderFns } from "./json-list.vue?vue&type=template&id=573bec3e&scoped=true&"
import script from "./json-list.vue?vue&type=script&lang=js&"
export * from "./json-list.vue?vue&type=script&lang=js&"
import style0 from "./json-list.vue?vue&type=style&index=0&id=573bec3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573bec3e",
  null
  
)

export default component.exports